import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Divider,
  Upload,
  message,
  Image,
  Tooltip,
  Spin,
  notification,
  Switch,
  Modal,
  Card,
  Space,
  Tabs,
  Select,
  Tag,
} from "antd";
import {
  UserOutlined,
  MailOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  LinkOutlined,
  CloudUploadOutlined,
  LoadingOutlined,
  PlusOutlined,
  PlayCircleOutlined,
  DeleteOutlined,
  InboxOutlined,
  LinkedinFilled,
  InstagramOutlined,
  FacebookFilled,
  TwitterOutlined,
  YoutubeFilled,
  FieldTimeOutlined,
  EditOutlined,
  LockOutlined,
  LockFilled,
  CrownOutlined,
  StarFilled,
  CheckCircleFilled,
  ArrowRightOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  link,
} from "suneditor/src/plugins";
import Repeater from "../components/EditProfile/Repeater";
import Colorpick from "../components/EditProfile/Colorpick";
import * as InspectorProfileService from "../services/InspectorProfile";
import * as AutosaveService from "../services/autosaveService";
import SpinWaitCustom from '../components/SpinnerWait';
import { MEDIA_UPLOAD_URL, WEBSITE_URL } from "../Helper";
import * as UserDataService from '../services/GetUserData';
import * as Actions from '../store/actions/user';
const { TextArea } = Input;
function InspectorProfile() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isPrivateAddress, setIsPrivateAddress] = useState(false);
  const [profilePicLoading, setProfilePicLoading] = useState(false);
  const [profilePicId, setProfilePicId] = useState("");
  const [loadinglogo, setLoadinglogo] = useState(false);
  const [loadingBgCheck, setLoadingBgCheck] = useState(false);
  const [loadingsign, setLoadingsign] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [nwfaCertified, setNwfaCertified] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [signUrl, setSignUrl] = useState("");
  const [signID, setSignID] = useState("");
  const [LogoimageUrl, setLogoImageUrl] = useState("");
  const [BgCheckimageUrl, setBgCheckImageUrl] = useState("");
  const [bgCheckImageEntension, setBgCheckImageEntension] = useState();
  const [BgCheckimageID, setBgCheckimageID] = useState("");
  const [footerLogo, setFooterLogo] = useState([]);
  const [inspectorTypes, setInspectorTypes] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const profile_id = queryParams.get("inspector_id");
  const [aboutMe, setAboutMe] = useState("");
  const [privateNotes, setPrivateNotes] = useState("");
  const [invoiceNotes, setInvoiceNotes] = useState("");
  const [formData, setFormData] = useState({});
  const [selectedInspectorTypes, setSelectedInspectorTypes] = useState([]);
  const [pdfColor, setPdfColor] = useState("");
  const [logoImageId, setLogoImageId] = useState("");
  const [items, setItems] = useState([{ file: null, file_id: null, loading: false, certification_authority: '', date: new Date() }]);
  const [autosaveEnabled, setAutosaveEnabled] = useState(false);
  const [autoGenerateInvoice, setAutoGenerateInvoice] = useState(true);
  const [preferredDateFormat, setPreferredDateFormat] = useState("MM/DD/YYYY");
  const [videos, setVideos] = useState([]);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const [uploadingVideos, setUploadingVideos] = useState([]);

  const [socialLinks, setSocialLinks] = useState({
    linkedin: "",
    instagram: "",
    facebook: "",
    twitter: "",
    youtube: ""
  });
  const [workExperience, setWorkExperience] = useState("");
  const userDetails = useSelector((state) => state.User?.userDetails);
  const isFreeInspector = Boolean(
    !userDetails?.is_admin &&
    userDetails?.user_role === 'um_inspector' &&
    (String(userDetails?.membersdhip_level) === '1' || userDetails?.limited_access === true)
  );
  const [upgradeModalVisible, setUpgradeModalVisible] = useState(false);
  const [upgradeFeatureName, setUpgradeFeatureName] = useState('');

  const promptUpgrade = (featureName) => {
    setUpgradeFeatureName(featureName);
    setUpgradeModalVisible(true);
  };

  const beforeUploadVideo = (file) => {
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    
    if (fileExtension === '.mov') {
      message.error('.mov files are not supported. Please convert to MP4 format.');
      return false;
    }
    
    const isVideo = file.type.startsWith('video/');
    if (!isVideo) {
      message.error('You can only upload video files!');
      return false;
    }
    const isLt100M = file.size / 1024 / 1024 < 100;
    if (!isLt100M) {
      message.error('Video must be smaller than 100MB!');
      return false;
    }
    return true;
  };

  const getVideoDuration = (videoElement) => {
    const duration = videoElement.duration;
    if (!duration || isNaN(duration)) return null;
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const loadVideoDuration = (videoUrl, videoId) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      if (video.duration && !isNaN(video.duration)) {
        const duration = getVideoDuration(video);
        setVideos(prev => prev.map(v => 
          v.id === videoId ? {...v, duration} : v
        ));
      }
    };
  };

  const getTimeAgo = (uploadDate) => {
    const now = new Date();
    const uploaded = new Date(uploadDate);
    const diffInMs = now - uploaded;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) return 'Today';
    if (diffInDays === 1) return '1 day ago';
    if (diffInDays < 7) return `${diffInDays} days ago`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} week${Math.floor(diffInDays / 7) > 1 ? 's' : ''} ago`;
    if (diffInDays < 365) return `${Math.floor(diffInDays / 30)} month${Math.floor(diffInDays / 30) > 1 ? 's' : ''} ago`;
    return `${Math.floor(diffInDays / 365)} year${Math.floor(diffInDays / 365) > 1 ? 's' : ''} ago`;
  };

  const handleVideoUpload = async (options) => {
    const { onSuccess, onError, file } = options;
    const tempId = `${Date.now()}_${file.name}`;
    const videoUrl = URL.createObjectURL(file);

    setUploadingVideos(prev => [...prev, { tempId, name: file.name, url: videoUrl }]);

    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    };
    fmData.append('file', file);

    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      setUploadingVideos(prev => prev.filter(v => v.tempId !== tempId));
      const newVideo = { 
        id: res.data.id, 
        url: res.data.source_url || res.data.url,
        name: file.name,
        uploadDate: new Date().toISOString()
      };
      setVideos(prev => [...prev, newVideo]);
      loadVideoDuration(newVideo.url, newVideo.id);
      message.success('Video uploaded successfully!');
      onSuccess(res.data.id);
    } catch (err) {
      console.error('Video upload error:', err);
      setUploadingVideos(prev => prev.filter(v => v.tempId !== tempId));
      message.error(`Failed to upload ${file.name}`);
      onError(err);
    }
  };

  const handleVideoDelete = (videoId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this inspector bio video? This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        setVideos(prev => prev.filter(v => v.id !== videoId));
        message.success('Video removed!');
      }
    });
  };

  const handleVideoPlay = (video) => {
    setCurrentVideo(video);
    setVideoModalVisible(true);
  };
  var dispatch = useDispatch();
  const getUserDetails = () => {
    dispatch(UserDataService.getUserData())
      .then((res) => {
        dispatch(Actions.set_user_auth(res));
        if (res?.expired === true || res?.remaining_inspections <= 0) {
          window.location.href = `${WEBSITE_URL}/plan-expired`;
        }
        if (
          res?.membersdhip_level === '7' ||
          res?.user_role === 'um_retailer' ||
          res?.user_role === 'um_dealer'
        ) {
          window.location.href = `${WEBSITE_URL}/`;
        }
        if (res?.companycam_token) {
          localStorage.setItem('companycam_token', res.companycam_token);
        }
      })
      .catch((err) => {
        // Extract and display a meaningful error message
        let errorMessage;

        if (err.response) {
          // The request was made and the server responded with a status code outside of the 2xx range
          errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
        } else if (err.request) {
          // The request was made but no response was received
          errorMessage = "No response received from the server. Please check your network connection.";
        } else {
          // Something else happened while setting up the request
          errorMessage = `An unexpected error occurred: ${err.message}`;
        }

        // Display the error message in an alert or use a UI notification component
        notification.error({ message: 'Error', description: errorMessage });
      });
  };
  const fetchProfileData = (params = {}) => {
    getUserDetails();
    setLoadings(true);
    setLoading(true);
    dispatch(InspectorProfileService.getInspectorProfileData(profile_id))
      .then((res) => {
        setFormData(res);
        setInspectorTypes(res.all_inspector_types);
        setSelectedInspectorTypes(res.inspector_type)
        setFooterLogo(res.all_footer_logos);
        setImageUrl(res.profile_pic);
        setProfilePicId(res.profile_pic_id);
        setLogoImageId(res.logo);
        setSignID(res.sign_for_report);
        setBgCheckimageID(res.background_check);
        setBgCheckImageUrl(res.BgCheckimageUrl);
        let fileExtension = res.BgCheckimageUrl.split('.');
        let lastElement = fileExtension[fileExtension.length - 1];
        setBgCheckImageEntension(lastElement);
        setSignUrl(res.signurl);
        setLogoImageUrl(res.logo_url);
        setAboutMe(res.about_me);
        setPrivateNotes(res.inspector_private_notes);
        setInvoiceNotes(res.invoice_extra_notes);
        setIsPrivateAddress(res.make_address_private);
        setPdfColor(res.pdf_color);
        setAutoGenerateInvoice(res.auto_generate_invoice !== '0');
        if (res.preferred_date_format) {
          setPreferredDateFormat(res.preferred_date_format);
        }
        if (res.certificates && res.certificates !== '') {
          setItems(res.certificates);
        }
        setNwfaCertified(res.nwfa_certified);
        setSocialLinks({
          linkedin: res.linkedin || "",
          instagram: res.instagram || "",
          facebook: res.facebook || "",
          twitter: res.twitter || "",
          youtube: res.youtube || ""
        });
        setWorkExperience(res.work_experience || "");
        // Process videos to ensure proper URLs and upload dates
        const processedVideos = (res.videos || []).map(video => {
          if (video.id && !video.url) {
            return {
              ...video,
              url: `https://www.floordetective.com/wp-content/uploads/${video.id}`,
              thumbnail: video.thumbnail || video.url,
              uploadDate: video.uploadDate || new Date().toISOString()
            };
          }
          return {
            ...video,
            uploadDate: video.uploadDate || new Date().toISOString()
          };
        });
        setVideos(processedVideos);
        // Load duration for existing videos
        processedVideos.forEach(video => {
          if (video.url && !video.duration) {
            loadVideoDuration(video.url, video.id);
          }
        });
        setLoading(false);
        setLoadings(false);
      })
      .catch((err) => {
        console.info("Get Error Edit State...");
        setLoading(false);
        setLoadings(false);
      });
  };
  function renderImage() {
    if (bgCheckImageEntension === 'pdf') {
      return (
        <img
          src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/13062734/PDF_file_icon.svg_65f17f92c093265f17f92c09d7.png"
          alt="PDF icon"
          style={{ width: "100%", height: "70px", objectFit: "contain" }}
        />
      );
    } else if (bgCheckImageEntension === 'docx' || bgCheckImageEntension === 'doc') {
      return (
        <img
          src="https://fddatainsp.s3.us-east-2.amazonaws.com/wp-content/uploads/2024/03/13062726/824298865f17f8c0ccdf65f17f8c0cd69.png"
          alt="DOCX/DOC icon"
          style={{ width: "100%", height: "70px", objectFit: "contain" }}
        />
      );
    } else if (bgCheckImageEntension === "jpg" || bgCheckImageEntension === "png" || bgCheckImageEntension === "jpeg") {
      return (
        <img
          src={BgCheckimageUrl}
          alt="Uploaded-img"
          style={{ width: "100%" }}
        />
      );
    } else {
      return (
        // <UploadOutlined />
        BgCheckuploadButton
      );
    }
  }
  const onFinish = (values) => {
    setLoadings(true);
    message.loading('Action in progress..');
    values.profile_id = profile_id;
    values.profile_pic_id = profilePicId;
    values.sign_for_report = signID;
    values.inspectorTypes = inspectorTypes;
    values.about_me = aboutMe;
    values.invoice_extra_notes = invoiceNotes;
    values.inspector_private_notes = privateNotes;
    values.pdf_color = pdfColor;
    values.company_logo = logoImageId;
    values.background_check = BgCheckimageID;
    values.certificates = items;
    values.auto_generate_invoice = autoGenerateInvoice;
    values.linkedin = socialLinks.linkedin;
    values.instagram = socialLinks.instagram;
    values.facebook = socialLinks.facebook;
    values.twitter = socialLinks.twitter;
    values.youtube = socialLinks.youtube;
    values.work_experience = workExperience;
    values.videos = videos;
    values.preferred_date_format = preferredDateFormat;
    // values.signUrl = signUrl;

    if (isFreeInspector) {
      // Preserve existing values for locked fields so no data is lost
      if (formData?.website) values.website = formData.website;
      if (formData?.make_address_private !== undefined) values.make_address_private = formData.make_address_private;
      if (formData?.address_hide_report !== undefined) values.address_hide_report = formData.address_hide_report;
      if (formData?.hide_my_profile !== undefined) values.hide_my_profile = formData.hide_my_profile;
      if (formData?.inspector_type && formData.inspector_type.length > 0) values.inspectorTypes = formData.inspector_type;
      if (formData?.second_group) values.second_group = formData.second_group;
      if (formData?.linkedin) values.linkedin = formData.linkedin;
      if (formData?.instagram) values.instagram = formData.instagram;
      if (formData?.facebook) values.facebook = formData.facebook;
      if (formData?.twitter) values.twitter = formData.twitter;
      if (formData?.youtube) values.youtube = formData.youtube;
      if (formData?.work_experience) values.work_experience = formData.work_experience;
      if (formData?.company_logo || formData?.logo) values.company_logo = formData.company_logo || formData.logo;
      if (formData?.background_check) values.background_check = formData.background_check;
      if (formData?.sign_for_report) values.sign_for_report = formData.sign_for_report;
      if (formData?.pdf_color) values.pdf_color = formData.pdf_color;
      if (formData?.auto_generate_invoice !== undefined) values.auto_generate_invoice = formData.auto_generate_invoice !== '0';
      if (formData?.videos) values.videos = formData.videos;
    }

    dispatch(InspectorProfileService.updateInspectorProfile(values))
      .then((res) => {
        setFormData(res);
        getUserDetails();
        message.success("Profile updated successfully!");
        setLoadings(false);
      })
      .catch((err) => {
        message.error("Unable to update Profile");
        setLoadings(false);
      });
  };
  useEffect(() => {
    fetchProfileData();
    AutosaveService.getAutosaveSetting()
      .then(res => {
        setAutosaveEnabled(res.data.enabled);
      })
      .catch(err => {
        console.error("Error fetching autosave setting", err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAutosaveChange = (checked) => {
    setAutosaveEnabled(checked);
    AutosaveService.updateAutosaveSetting({ enabled: checked })
      .then(res => {
        message.success("Autosave setting updated.");
      })
      .catch(err => {
        message.error("Failed to update autosave setting.");
        // Revert the switch state on failure
        setAutosaveEnabled(!checked);
      });
  };

  const handleAutoGenerateInvoiceChange = (checked) => {
    setAutoGenerateInvoice(checked);
  };

  const onChangeInspectorTypes = (checkedValues) => {
    const nwfaHardwoodId = 80;
    const isCertified = String(nwfaCertified) === '1';

    const wasPreviouslyChecked = Array.isArray(selectedInspectorTypes) && selectedInspectorTypes.some(id => Number(id) === nwfaHardwoodId);
    const isNowChecked = checkedValues.some(id => Number(id) === nwfaHardwoodId);
    const isTryingToSelectNwfa = !wasPreviouslyChecked && isNowChecked;

    // Validate NWFA certification: Only block if the user is trying to check NWFA Hardwood while NOT certified
    if (isTryingToSelectNwfa && !isCertified) {
      const filteredValues = checkedValues.filter(id => Number(id) !== nwfaHardwoodId);
      setSelectedInspectorTypes(filteredValues);
      form.setFieldsValue({ inspector_type: filteredValues });

      const hasNwfaCertificateUploaded = Array.isArray(items) && items.some(
        cert => (cert.certification_authority === 'NWFA' || cert.certification_authority === 'NWFA Wood Flooring')
      );

      if (hasNwfaCertificateUploaded) {
        Swal.fire({
          icon: 'info',
          title: 'Certification Under Review',
          text: 'Your NWFA certificate has been submitted and is currently pending verification by the administrator. Once verified, you will be able to select this specialty.',
          confirmButtonColor: '#0a497b',
          confirmButtonText: 'OK'
        });
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'NWFA Certification Required',
          text: 'You must be NWFA certified to select NWFA Hardwood inspector type. Please upload your certificate in the "Certification & Cv" tab.',
          confirmButtonColor: '#0a497b',
          confirmButtonText: 'OK'
        });
      }
      return;
    }

    // If validation passes, update selected types
    setSelectedInspectorTypes(checkedValues);
  };


  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleTabChange = (key) => {
    console.log(`Tab changed to: ${key}`);
  };

  const onChangeAboutMe = (editorData) => {
    setAboutMe(editorData);
  };
  const onChangePrivateNotes = (editorData) => {
    setPrivateNotes(editorData);
  };
  const onChangeInvoiceNotes = (editorData) => {
    setInvoiceNotes(editorData);
  };
  const SunEditorOpts = {
    showPathLabel: false,
    height: "auto",
    minHeight: "200px",
    requestHeaders: {
      "X-Sample": "sample",
    },
    plugins: [
      align,
      font,
      fontColor,
      fontSize,
      formatBlock,
      hiliteColor,
      horizontalRule,
      lineHeight,
      list,
      paragraphStyle,
      table,
      template,
      textStyle,
      link,
    ],
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["paragraphStyle"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor"],
      ["removeFormat"],
      ["align", "horizontalRule", "lineHeight"],
      ["outdent", "indent"],
      ["list"],
      ["table", "link"],
      ["fullScreen", "showBlocks", "preview"],
    ],
    formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
    font: [
      "Arial",
      "Calibri",
      "Comic Sans",
      "Courier",
      "Garamond",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Palatino Linotype",
      "Segoe UI",
      "Tahoma",
      "Times New Roman",
      "Trebuchet MS",
      "Roboto",
    ],
  };


  const normFile = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };


  const handleChangeSignature = (info) => {
    if (info.file.status === "uploading") {
      setLoadingsign(true);
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoadingsign(false);
        ///setImageUrl(url);
        setSignUrl(url);
        setSignID(info.file.response);
        //props.values.signurl = url;
      });
    }
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };
  const beforeUploadSign = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }

    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Sign
      </div>
    </div>
  );

  const normFileLogo = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleChangeImageLogo = (info) => {
    if (info.file.status === "uploading") {
      setLoadinglogo(true);
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoadinglogo(false);
        setLogoImageUrl(url);
        setLogoImageId(info.file.response);
        //props.values.signurl = url;
      });
    }
  };

  const beforeUploadLogo = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }

    return isJpgOrPng && isLt2M;
  };
  const LogouploadButton = (
    <div>
      {loadinglogo ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload logo
      </div>
    </div>
  );

  const normFileBgCheck = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const handleChangeImageBgCheck = (info) => {
    if (info.file.status === "uploading") {
      setLoadingBgCheck(true);
      return;
    }

    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, (url) => {
        // setLoadinglogo(false);
        setLoadingBgCheck(false);
        setBgCheckImageUrl(url);
        let fileExtension = info.file.name.split('.');

        let lastElement = fileExtension[fileExtension.length - 1];
        setBgCheckImageEntension(lastElement);
        setBgCheckimageID(info.file.response);
      });
    }
  };
  const beforeUploadBgCheck = (file) => {
    const allowedFileTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedFileTypes.includes(file.type)) {
      message.error("You can only upload JPG, PNG, PDF, or DOCX files!");
      return false;
    }

    const isLt20M = file.size / 1024 / 1024 < 20;

    if (!isLt20M) {
      message.error("Image must smaller than 20MB!");
    }

    return allowedFileTypes.includes(file.type) && isLt20M;
  };
  const BgCheckuploadButton = (
    <div>
      {loadingBgCheck ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Add File
      </div>
    </div>
  );
  console.log("yyy", formData);
  const handleProfileImageChange = (info) => {
    if (info.file.status === "uploading") {
      setProfilePicLoading(true);
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setProfilePicLoading(false);
        setImageUrl(url);
        setProfilePicId(info.file.response);
        console.warn('profile image', info.file);
        //props.values.signurl = url;
      });
    }
  };
  const ProfileuploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload Profile
      </div>
    </div>
  );
  // Define your custom request function for the API upload
  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
      },
    };
    fmData.append('file', file);
    try {
      const res = await axios.post(MEDIA_UPLOAD_URL, fmData, config);
      console.info("UPLOADED");
      onSuccess(res.data.id);
    } catch (err) {
      console.log('Eroor: ', err);
      const error = new Error('Some error');
      onError({ err });
      console.warn(error);
    }
  };


  const handlePrivateCheckboxChange = () => {
    setIsPrivateAddress(!isPrivateAddress);
  };

  const handleSocialLinkChange = (platform, value) => {
    setSocialLinks(prev => ({
      ...prev,
      [platform]: value
    }));
  };

  const getSocialIcon = (platform) => {
    const icons = {
      linkedin: <LinkedinFilled style={{ color: '#0077B5', fontSize: '18px' }} />,
      instagram: <InstagramOutlined style={{ color: '#E4405F', fontSize: '18px' }} />,
      facebook: <FacebookFilled style={{ color: '#1877F2', fontSize: '18px' }} />,
      twitter: <TwitterOutlined style={{ color: '#1DA1F2', fontSize: '18px' }} />,
      youtube: <YoutubeFilled style={{ color: '#FF0000', fontSize: '18px' }} />
    };
    return icons[platform];
  };

  return (
    <div className="container-xxl inspector-profile-container">
      <Row justify="center">
        <Col xs={24} md={20}>
          {Object.keys(formData).length === 0 ? (
            // Loading indicator or placeholder while data is being fetched
            <SpinWaitCustom />
          ) : (
            <Form
              form={form}
              name="editProfileForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={formData}
            >
              <Row gutter={16}>
                <Col xs={24} md={24} xl={24}>
                  <div className={`avatar-wrapper ${isFreeInspector && Boolean(imageUrl) ? 'avatar-locked' : ''}`}>
                    <Spin spinning={profilePicLoading}>
                      <Upload
                        className="profile-image-upload"
                        customRequest={uploadImage}
                        showUploadList={false}
                        onChange={handleProfileImageChange}
                        disabled={isFreeInspector && Boolean(imageUrl)}
                        beforeUpload={(file) => {
                          if (isFreeInspector && Boolean(imageUrl)) {
                            message.warning("Profile photo can only be set once on the Free Plan. Upgrade your membership to change it.");
                            promptUpgrade("Profile Photo Customization");
                            return false;
                          }
                          return true;
                        }}
                      >
                        {imageUrl ? (
                          <img
                            src={imageUrl}
                            alt="avatar"
                            className="profileImage-Box"
                            style={{
                              width: '100%',
                            }}
                          />
                        ) : (
                          ProfileuploadButton
                        )}

                        {(!isFreeInspector || !imageUrl) && (
                          <Tooltip title="Upload Profile Picture">
                            <div className="upload-button">
                              <CloudUploadOutlined />
                            </div>
                          </Tooltip>
                        )}
                      </Upload>
                    </Spin>

                    {isFreeInspector && Boolean(imageUrl) && (
                      <>
                        <div
                          className="avatar-hover-upgrade-overlay"
                          onClick={(e) => {
                            e.stopPropagation();
                            promptUpgrade("Profile Photo Customization");
                          }}
                        >
                          <CrownOutlined className="avatar-upgrade-crown" />
                          <span className="avatar-upgrade-text">Upgrade to Change</span>
                        </div>
                        <div className="avatar-corner-crown" title="Free Plan: 1 Photo Allowed. Upgrade to change.">
                          <CrownOutlined />
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
              {/* Name input */}

              <Row gutter={16}>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Organization name"
                    name="organization_name"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="organization"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Full name"
                    name="insp_fullname"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input prefix={<UserOutlined />} placeholder="Full name" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Address"
                    name="address"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    rules={[
                      { required: true, message: "Please input your address!" },
                    ]}
                  >
                    <Input
                      prefix={<EnvironmentOutlined />}
                      placeholder="Address"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Email"
                    name="email"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    rules={[
                      { required: true, message: "Please input your email!" },
                    ]}
                  >
                    <Input prefix={<MailOutlined />} placeholder="Email" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Phone Number"
                    name="phone_number"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      prefix={<PhoneOutlined />}
                      placeholder="Phone Number"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label={
                      <span>
                        Website {isFreeInspector && (
                          <span
                            className="fd-upgrade-badge"
                            style={{ marginLeft: '8px' }}
                            onClick={() => promptUpgrade('Website Integration')}
                          >
                            <CrownOutlined /> Upgrade
                          </span>
                        )}
                      </span>
                    }
                    name="website"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      prefix={<LinkOutlined />}
                      placeholder="Website"
                      readOnly={isFreeInspector}
                      onClick={isFreeInspector ? () => promptUpgrade('Website Integration') : undefined}
                      style={isFreeInspector ? { cursor: 'pointer', backgroundColor: '#f8fafc' } : {}}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Company phone number"
                    name="company_phone_number"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      prefix={<PhoneOutlined />}
                      placeholder="Company phone number"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Location Title"
                    name="location_title"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    rules={[
                      { required: true, message: "Please input Location title!" },
                    ]}
                  >
                    <Input
                      prefix={<EnvironmentOutlined />}
                      placeholder="Location Title"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    label="Inspector Certification/CP #"
                    name="inspector_certificationcp"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input
                      prefix={<UserOutlined />}
                      placeholder="Inspector Certification/CP"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={24} xl={24}>
                  <h6 className="hide-and-private" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>Hide & Private Fields</span>
                    {isFreeInspector && (
                      <span
                        className="fd-upgrade-badge"
                        onClick={() => promptUpgrade('Privacy & Visibility Controls')}
                      >
                        <CrownOutlined /> Upgrade
                      </span>
                    )}
                  </h6>
                  <Divider></Divider>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    name="make_address_private"
                    valuePropName="checked"
                    onChange={isFreeInspector ? undefined : handlePrivateCheckboxChange}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Checkbox
                      disabled={isFreeInspector}
                      onClick={isFreeInspector ? () => promptUpgrade('Make Address Private') : undefined}
                    >
                      Make address private
                    </Checkbox>
                  </Form.Item>
                  {isPrivateAddress && (
                    <Form.Item
                      label="Zipcode"
                      name="zip_code"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Input
                        prefix={<EnvironmentOutlined />}
                        placeholder="Zipcode"
                      />
                    </Form.Item>
                  )}
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    name="address_hide_report"
                    valuePropName="checked"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Checkbox
                      disabled={isFreeInspector}
                      onClick={isFreeInspector ? () => promptUpgrade('Address Hide for Reports') : undefined}
                    >
                      Address hide for invoice and report
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} md={8} xl={8}>
                  <Form.Item
                    name="hide_my_profile"
                    valuePropName="checked"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Checkbox
                      disabled={isFreeInspector}
                      onClick={isFreeInspector ? () => promptUpgrade('Hide Profile Listing') : undefined}
                    >
                      Hide my profile in the inspector listing.
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
              {/* <Row gutter={16}> */}
              <div className="inspector-types">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <h6 style={{ margin: 0 }}>Inspector Type</h6>
                  {isFreeInspector && (
                    <span
                      className="fd-upgrade-badge"
                      onClick={() => promptUpgrade('Specialty Categories Customization')}
                    >
                      <CrownOutlined /> Upgrade
                    </span>
                  )}
                </div>
                <Divider></Divider>
                <div className={isFreeInspector ? "locked-blur-types-container" : ""}>
                  <Form.Item name="inspector_type">
                    <Checkbox.Group style={{ width: "100%" }} onChange={onChangeInspectorTypes} disabled={isFreeInspector}>
                      <Row gutter={16}>
                        {inspectorTypes.map((type) => (
                          type.parent === 0 && (
                            <Col xs={24} md={8} xl={8} key={type.term_id}>
                              <Checkbox value={type.term_id}>{type.name}</Checkbox>
                            </Col>
                          )
                        ))}
                      </Row>
                    </Checkbox.Group>
                  </Form.Item>
                  {selectedInspectorTypes && selectedInspectorTypes.includes(84) && (
                    <Form.Item name="second_group">
                      <Checkbox.Group style={{ width: "100%", backgroundColor: "#f0f0f0", padding: "10px", border: "1px inset #ccc" }} disabled={isFreeInspector}>
                        <Row gutter={16}>
                          {inspectorTypes
                            .filter(type => type.parent === 84)
                            .map((type) => (
                              <Col xs={24} md={8} xl={8} key={type.term_id}>
                                <Checkbox value={type.term_id}>{type.name}</Checkbox>
                              </Col>
                            ))}
                        </Row>
                      </Checkbox.Group>
                    </Form.Item>
                  )}
                  {isFreeInspector && (
                    <div
                      className="locked-types-overlay-badge"
                      onClick={() => promptUpgrade('Specialty Categories Customization')}
                    >
                      <CrownOutlined style={{ color: '#ffd700' }} /> Specialties set at registration. Upgrade to edit.
                    </div>
                  )}
                </div>
              </div>
              <Row gutter={16}></Row>

              <Tabs
                className="profile-tab-section"
                defaultActiveKey="1"
                onChange={handleTabChange}
              >
                <Tabs tab="About" key="1">
                  <span className="tab-content-title">About Me</span>
                  <div className="text-editor-wrapper">
                    <SunEditor
                      setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                      setOptions={SunEditorOpts}
                      setContents={aboutMe}
                      onChange={onChangeAboutMe}
                    />
                  </div>
                  
                  <Divider />
                  <span className="tab-content-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>Social Media Links</span>
                    {isFreeInspector && (
                      <span
                        className="fd-upgrade-badge"
                        onClick={() => promptUpgrade('Social Media Integration')}
                      >
                        <CrownOutlined /> Upgrade
                      </span>
                    )}
                  </span>
                  <Row gutter={16}>
                    {Object.entries(socialLinks).map(([platform, url]) => (
                      <Col xs={24} md={12} key={platform}>
                        <div style={{ marginBottom: '16px' }}>
                          <div style={{ marginBottom: '8px', fontWeight: '500', color: '#333', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {getSocialIcon(platform)} {platform.charAt(0).toUpperCase() + platform.slice(1)}
                          </div>
                          <Input
                            className="formControl"
                            placeholder={isFreeInspector ? (url || `No ${platform} link provided`) : `Enter your ${platform} URL`}
                            value={url}
                            readOnly={isFreeInspector}
                            onChange={isFreeInspector ? undefined : (e) => handleSocialLinkChange(platform, e.target.value)}
                            onClick={isFreeInspector ? () => promptUpgrade('Social Media Integration') : undefined}
                            style={isFreeInspector ? { backgroundColor: '#f8fafc', cursor: 'pointer' } : {}}
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                  
                  <Divider />
                  <span className="tab-content-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>Work Experience & Past Projects</span>
                    {isFreeInspector && (
                      <span
                        className="fd-upgrade-badge"
                        onClick={() => promptUpgrade('Work Experience & Project Portfolio')}
                      >
                        <CrownOutlined /> Upgrade
                      </span>
                    )}
                  </span>
                  <div className={`text-editor-wrapper ${isFreeInspector ? 'locked-editor-wrapper' : ''}`}>
                    <SunEditor
                      setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                      setOptions={SunEditorOpts}
                      setContents={workExperience}
                      onChange={isFreeInspector ? undefined : setWorkExperience}
                      disable={isFreeInspector}
                    />
                    {isFreeInspector && (
                      <div
                        className="locked-editor-overlay"
                        onClick={() => promptUpgrade('Work Experience & Project Portfolio')}
                      >
                        <div className="locked-editor-badge">
                          <CrownOutlined style={{ color: '#ffd700' }} /> Upgrade to showcase your Portfolio
                        </div>
                      </div>
                    )}
                  </div>
                  

                  <Divider />
                  <span className="tab-content-title">Certifications logo</span>
                  <Row className="my-2 footerRow" gutter={6}>
                    <Form.Item name="footerlogos">
                      <Checkbox.Group>
                        {footerLogo.map((logo) => (
                          <Col className="col-auto h-100">
                            <div className="logoDiv">
                              <Checkbox value={logo.logo_id}>
                                <label htmlFor={logo.logo_id}>
                                  <Image
                                    src={logo.logo_url}
                                    className="img-fluid"
                                    alt="logos"
                                    preview={false}
                                  />
                                </label>
                              </Checkbox>
                            </div>
                          </Col>
                        ))}
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                </Tabs>
                <Tabs tab="Private Notes" key="2">
                  <span className="tab-content-title">Private Notes</span>
                  <div className="text-editor-wrapper">
                    <SunEditor
                      setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                      setOptions={SunEditorOpts}
                      setContents={privateNotes}
                      onChange={onChangePrivateNotes}
                    />
                  </div>
                </Tabs>

                
                <Tabs tab="Report Writer Settings" key="3">
                  {/* <span className='tab-content-title'>Report Writer Settings</span> */}
                  <Row gutter={16}>
                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 className="pdf-color-label" style={{ margin: 0 }}>Company Logo</h6>
                          {isFreeInspector && (
                            <span className="fd-upgrade-badge" onClick={() => promptUpgrade("Company Logo on Reports")}>
                              <CrownOutlined /> Upgrade
                            </span>
                          )}
                        </div>
                        <Divider></Divider>
                        <div className="image-wrapper">
                          <div className={isFreeInspector ? "locked-upload-wrapper" : ""}>
                            {isFreeInspector && (
                              <div className="locked-upload-overlay" onClick={() => promptUpgrade("Company Logo on Reports")}>
                                <div className="locked-upload-icon-circle">
                                  <CrownOutlined />
                                </div>
                                <span className="locked-upload-title">Premium Feature</span>
                                <span className="locked-upload-sub">Upgrade to add company logo</span>
                              </div>
                            )}
                            <Form.Item
                              name="logoUpload"
                              valuePropName="fileList"
                              getValueFromEvent={normFileLogo}
                            >
                              <Spin className="spin-company-logo" spinning={loadinglogo}>
                                <Upload
                                  name="avatar"
                                  listType="picture-card"
                                  className="avatar-uploader"
                                  showUploadList={false}
                                  customRequest={uploadImage}
                                  beforeUpload={beforeUploadLogo}
                                  onChange={handleChangeImageLogo}
                                  maxCount={1}
                                  loading={loadinglogo}
                                  disabled={isFreeInspector}
                                >
                                  {LogoimageUrl ? (
                                    <img
                                      src={LogoimageUrl}
                                      alt="avatar"
                                      style={{
                                        width: "100%",
                                      }}
                                    />
                                  ) : (
                                    LogouploadButton
                                  )}
                                </Upload>
                              </Spin>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 className="pdf-color-label" style={{ margin: 0 }}>Background check</h6>
                          {isFreeInspector && (
                            <span className="fd-upgrade-badge" onClick={() => promptUpgrade("Background Check Badge")}>
                              <CrownOutlined /> Upgrade
                            </span>
                          )}
                        </div>
                        <Divider></Divider>
                        <div className="image-wrapper">
                          <div className={isFreeInspector ? "locked-upload-wrapper" : ""}>
                            {isFreeInspector && (
                              <div className="locked-upload-overlay" onClick={() => promptUpgrade("Background Check Badge")}>
                                <div className="locked-upload-icon-circle">
                                  <CrownOutlined />
                                </div>
                                <span className="locked-upload-title">Premium Feature</span>
                                <span className="locked-upload-sub">Upgrade to add badge</span>
                              </div>
                            )}
                            <Form.Item
                              name="logoUpload"
                              valuePropName="fileList"
                              getValueFromEvent={normFileBgCheck}
                            >
                              <Spin className="spin-loadingBg" spinning={loadingBgCheck}>
                                <Upload
                                  name="avatar"
                                  listType="picture-card"
                                  className="avatar-uploader"
                                  showUploadList={false}
                                  customRequest={uploadImage}
                                  beforeUpload={beforeUploadBgCheck}
                                  onChange={handleChangeImageBgCheck}
                                  disabled={isFreeInspector}
                                >
                                  {renderImage()}
                                </Upload>
                              </Spin>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Divider />
                  <Row gutter={16}>
                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 className="pdf-color-label" style={{ margin: 0 }}>Signature</h6>
                          {isFreeInspector && (
                            <span className="fd-upgrade-badge" onClick={() => promptUpgrade("Digital Signature on Reports")}>
                              <CrownOutlined /> Upgrade
                            </span>
                          )}
                        </div>
                        <Divider></Divider>
                        <div className="image-wrapper">
                          <div className={isFreeInspector ? "locked-upload-wrapper" : ""}>
                            {isFreeInspector && (
                              <div className="locked-upload-overlay" onClick={() => promptUpgrade("Digital Signature on Reports")}>
                                <div className="locked-upload-icon-circle">
                                  <CrownOutlined />
                                </div>
                                <span className="locked-upload-title">Premium Feature</span>
                                <span className="locked-upload-sub">Upgrade to add signature</span>
                              </div>
                            )}
                            <Form.Item
                              name="upload"
                              valuePropName="fileList"
                              getValueFromEvent={normFile}
                            >
                              <Spin className="spin-loadingsign" spinning={loadingsign}>
                                <Upload
                                  name="avatar"
                                  listType="picture-card"
                                  className="avatar-uploader signature-upload"
                                  showUploadList={false}
                                  customRequest={uploadImage}
                                  beforeUpload={beforeUploadSign}
                                  onChange={handleChangeSignature}
                                  disabled={isFreeInspector}
                                >
                                  {console.info("signUrl", signUrl)}
                                  {signUrl ? (
                                    <img
                                      src={signUrl}
                                      alt="avatar"
                                      style={{
                                        width: "100%",
                                      }}
                                    />
                                  ) : (
                                    uploadButton
                                  )}
                                </Upload>
                              </Spin>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 className="pdf-color-label" style={{ margin: 0 }}>Pdf Color Setting</h6>
                          {isFreeInspector && (
                            <span className="fd-upgrade-badge" onClick={() => promptUpgrade("Custom PDF Theme Colors")}>
                              <CrownOutlined /> Upgrade
                            </span>
                          )}
                        </div>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <label style={{ margin: 0, fontWeight: 400 }}>Theme Color</label>
                          {isFreeInspector ? (
                            <Tooltip title="Custom report themes available when you upgrade">
                              <div
                                onClick={() => promptUpgrade("Custom PDF Theme Colors")}
                                style={{
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 8,
                                  padding: '4px 10px',
                                  border: '1px solid #bfdbfe',
                                  borderRadius: 6,
                                  background: '#f0f7ff',
                                  transition: 'all 0.2s'
                                }}
                              >
                                <div style={{ width: 18, height: 18, borderRadius: 4, background: pdfColor || '#0a497b', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.15)' }} />
                                <span style={{ fontSize: '12px', fontWeight: 600, color: '#0a497b' }}>Default Navy</span>
                                <CrownOutlined style={{ color: '#0a497b', fontSize: '12px' }} />
                              </div>
                            </Tooltip>
                          ) : (
                            <Colorpick color={pdfColor} setPdfColor={setPdfColor} />
                          )}
                        </div>
                        <div style={{ marginTop: '8px', color: '#64748b', fontSize: '12px' }}>
                          {isFreeInspector
                            ? 'Default theme active. Upgrade your membership to customize PDF report colors.'
                            : 'This color will be used for headings in the PDF report.'}
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <h6 className="pdf-color-label">Autosave Setting</h6>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <label style={{ margin: 0, fontWeight: 400 }}>Enable Autosave</label>
                          <Switch checked={autosaveEnabled} onChange={handleAutosaveChange} />
                        </div>
                        <div style={{ marginTop: '8px', color: '#888', fontSize: '12px' }}>
                          Automatically saves your changes while you work.
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} md={6} xl={6}>
                      <div className="pdf-color-settings">
                        <h6 className="pdf-color-label">Preferred Date Format</h6>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <label style={{ margin: 0, fontWeight: 400 }}>Select Format</label>
                          <Select
                            value={preferredDateFormat}
                            style={{ width: 140 }}
                            onChange={(value) => setPreferredDateFormat(value)}
                          >
                            <Select.Option value="MM/DD/YYYY">MM/DD/YYYY</Select.Option>
                            <Select.Option value="DD/MM/YYYY">DD/MM/YYYY</Select.Option>
                          </Select>
                        </div>
                        <div style={{ marginTop: '8px', color: '#888', fontSize: '12px' }}>
                          This format will be used for all system dates.
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col xs={24} md={8} xl={8}>
                      <div className="pdf-color-settings mb-4">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <h6 className="pdf-color-label" style={{ margin: 0 }}>Auto Generate Invoice Number Setting</h6>
                          {isFreeInspector && (
                            <span className="fd-upgrade-badge" onClick={() => promptUpgrade("Automatic Invoice Number Generation")}>
                              <CrownOutlined /> Upgrade
                            </span>
                          )}
                        </div>
                        <Divider />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <label style={{ margin: 0, fontWeight: 400 }}>Enable Auto Generate Invoice Number</label>
                          {isFreeInspector ? (
                            <Tooltip title="Available when you upgrade your membership">
                              <div onClick={() => promptUpgrade("Automatic Invoice Number Generation")} style={{ cursor: 'pointer' }}>
                                <Switch checked={false} disabled={true} />
                              </div>
                            </Tooltip>
                          ) : (
                            <Switch checked={autoGenerateInvoice} onChange={handleAutoGenerateInvoiceChange} />
                          )}
                        </div>
                        <div style={{ marginTop: '8px', color: '#64748b', fontSize: '12px' }}>
                          Automatically creates sequential invoice numbers for every inspection report. Upgrade to enable.
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={16} className="invoice-notes-row">
                    <Col xs={24} md={24} xl={24}>
                      <span className="tab-content-title">Invoice Notes</span>
                      <div className="text-editor-wrapper">
                        <SunEditor
                          setDefaultStyle="font-family: 'Poppins', sans-serif; font-size: 14px;"
                          setOptions={SunEditorOpts}
                          setContents={invoiceNotes}
                          onChange={onChangeInvoiceNotes}
                        />
                      </div>
                    </Col>
                  </Row>
                </Tabs>
                <Tabs tab="Certification & Cv" key="6">
                  <span className="tab-content-title">Certification & Cv</span>
                  <Repeater
                    items={items}
                    setItems={setItems}
                    nwfaCertified={nwfaCertified}
                    isFreeInspector={isFreeInspector}
                    onUpgrade={() => promptUpgrade("Unlimited Certifications & Badges")}
                  />
                </Tabs>
                <Tabs className="video-tab" tab="Inspector Bio" key="7">
                  <span className="tab-content-title">ADD Video</span>
                  
                  {isFreeInspector ? (
                    <div className="locked-video-upgrade-box">
                      <div className="locked-video-badge">
                        <CrownOutlined /> PREMIUM FEATURE
                      </div>
                      <h3>
                        Inspector Introduction Video Bio
                      </h3>
                      <p>
                        Video bios help you win more inspections by showcasing your personality, expertise, and professionalism directly to manufacturers and clients. Upgrade your membership to unlock video introductions.
                      </p>
                      <Button
                        type="primary"
                        size="large"
                        icon={<CrownOutlined />}
                        onClick={() => promptUpgrade("Inspector Video Bio")}
                        className="locked-video-btn"
                      >
                        Upgrade Membership to Unlock
                      </Button>
                    </div>
                  ) : (
                    <Upload.Dragger
                      customRequest={handleVideoUpload}
                      beforeUpload={beforeUploadVideo}
                      showUploadList={false}
                      accept="video/*"
                      multiple
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
                      </p>
                      <p className="ant-upload-text">Click or drag video files to this area to upload</p>
                      <p className="ant-upload-hint">Support for single or bulk upload. Only video files accepted (Max 100MB)</p>
                    </Upload.Dragger>
                  )}

                  <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
                        {uploadingVideos.map((video) => (
                          <Col xs={24} sm={12} md={8} key={video.tempId}>
                            <Card className="videocard-box"
                              cover={
                                <div style={{ position: 'relative', height: '220px', background: '#000', overflow: 'hidden' }}>
                                  <video src={video.url} style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(2px)' }} />
                                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                    <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 48, color: '#fff' }} spin />} />
                                    <div style={{ color: '#fff', fontSize: '14px', fontWeight: '500', marginTop: '12px' }}>
                                      Uploading<span>.</span><span>.</span><span>.</span>
                                    </div>
                                  </div>
                                </div>
                              }
                            />
                          </Col>
                        ))}
                        {[...videos].reverse().map((video, index) => {
                          return (
                          <Col xs={24} sm={12} md={8} key={video.id || index}>
                            <Card  className="videocard-box"
                              hoverable
                              cover={
                                <div style={{ position: 'relative', height: '220px', background: '#000', overflow: 'hidden' }}>
                                  {video.url ? (
                                    <video 
                                      src={video.url} 
                                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                      preload="metadata"
                                      muted
                                      onLoadedMetadata={(e) => {
                                        if (e.target.duration && !isNaN(e.target.duration)) {
                                          const duration = getVideoDuration(e.target);
                                          setVideos(prev => prev.map(v => 
                                            v.id === video.id ? {...v, duration} : v
                                          ));
                                        }
                                      }}
                                      onCanPlay={(e) => {
                                        if (e.target.duration && !isNaN(e.target.duration) && !video.duration) {
                                          const duration = getVideoDuration(e.target);
                                          setVideos(prev => prev.map(v => 
                                            v.id === video.id ? {...v, duration} : v
                                          ));
                                        }
                                      }}
                                    />
                                  ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff' }}>
                                      No video URL found
                                    </div>
                                  )}
                                  {video.duration && (
                                    <div style={{ zIndex:'2', position: 'absolute', bottom: '8px', right: '8px', background: '#0a497b', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>
                                      {video.duration}
                                    </div>
                                  )}
                                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)' }}>
                                    <PlayCircleOutlined 
                                      style={{ fontSize: '48px', color: '#fff', cursor: 'pointer' }}
                                      onClick={() => handleVideoPlay(video)}
                                    />
                                  </div>
                                </div>
                              }
                              actions={[
                                <Tooltip title="Play Video">
                                  <Button 
                                    type="primary" 
                                    shape="circle" 
                                    icon={<PlayCircleOutlined />} 
                                    onClick={() => handleVideoPlay(video)}
                                    style={{ backgroundColor: '#0a497b', borderColor: '#0a497b' }}
                                  />
                                </Tooltip>,
                                <Tooltip title="Upload Time">
                                  <div style={{ 
                                    display: 'inline-flex', 
                                    alignItems: 'center', 
                                    gap: '6px', 
                                    padding: '6px 7px',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: '500',
                                    color: '#fff',
                                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.3)'
                                  }}>
                                    <FieldTimeOutlined style={{ fontSize: '14px' }} /> 
                                    {video.uploadDate && getTimeAgo(video.uploadDate)}
                                  </div>
                                </Tooltip>,
                                <Tooltip title="Delete Video">
                                  <Button 
                                    type="primary" 
                                    danger 
                                    shape="circle" 
                                    icon={<DeleteOutlined />} 
                                    onClick={() => handleVideoDelete(video.id)}
                                  />
                                </Tooltip>
                              ]}
                            >
                            </Card>
                          </Col>
                        )})}
                      </Row>
                </Tabs>
              </Tabs>

              <Form.Item className="buttonOuter mt-4 text-center">
                <Button type="primary" htmlType="submit" loading={loadings}>
                  Update Profile
                </Button>
              </Form.Item>
            </Form>
          )}
        </Col>
      </Row>

      <Modal
        title="Video Preview"
        open={videoModalVisible}
        onCancel={() => setVideoModalVisible(false)}
        footer={null}
        width={800}
        centered
      >
        {currentVideo && (
          <video
            controls
            autoPlay
            style={{ width: '100%', maxHeight: '70vh' }}
            src={currentVideo.url}
          >
            Your browser does not support the video tag.
          </video>
        )}
      </Modal>

      <Modal
        wrapClassName="luxury-upgrade-modal-wrapper"
        className="luxury-upgrade-modal"
        open={upgradeModalVisible}
        onCancel={() => setUpgradeModalVisible(false)}
        footer={null}
        closable={false}
        centered
        width={580}
      >
        <div className="luxury-modal-content">
          <div className="luxury-modal-hero">
            <button
              type="button"
              className="luxury-close-btn"
              onClick={() => setUpgradeModalVisible(false)}
              aria-label="Close"
            >
              <CloseOutlined />
            </button>
            <div className="luxury-hero-tag">
              <StarFilled />
              <span>PREMIUM INSPECTOR TOOLS</span>
            </div>
            <div className="luxury-hero-main">
              <div className="luxury-crown-aura">
                <CrownOutlined />
              </div>
              <div className="luxury-hero-text">
                <h3>Unlock Full Professional Access</h3>
                <p>
                  <strong>{upgradeFeatureName || "This feature"}</strong> is available on upgraded plans. Elevate your inspection business with industry-leading branding and tools.
                </p>
              </div>
            </div>
          </div>
          <div className="luxury-modal-body">
            <div className="luxury-features-header">
              <span>EVERYTHING YOU UNLOCK WITH AN UPGRADED PLAN</span>
            </div>
            <div className="luxury-features-grid">
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Company Logo & Signature</h6>
                  <p>Custom branding on every PDF inspection report</p>
                </div>
              </div>
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Complete Privacy Controls</h6>
                  <p>Hide address & control public listing visibility</p>
                </div>
              </div>
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Custom PDF Report Themes</h6>
                  <p>Personalize colors to match your corporate brand</p>
                </div>
              </div>
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Inspector Video Introduction</h6>
                  <p>Win more inspections with a video bio</p>
                </div>
              </div>
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Unlimited Certifications</h6>
                  <p>Display all your badges, licenses & credentials</p>
                </div>
              </div>
              <div className="luxury-feature-item">
                <div className="luxury-feature-icon"><CheckCircleFilled /></div>
                <div className="luxury-feature-details">
                  <h6>Auto Invoice Numbering</h6>
                  <p>Sequential, automated billing on all your reports</p>
                </div>
              </div>
            </div>
            <div className="luxury-modal-footer">
              <Button
                type="primary"
                className="luxury-upgrade-btn"
                onClick={() => {
                  window.open(`${WEBSITE_URL}/membership-account/membership-levels/`, '_blank');
                  setUpgradeModalVisible(false);
                }}
              >
                <span>View Upgrade Plans & Pricing</span>
                <ArrowRightOutlined />
              </Button>
              <div className="luxury-footer-sub">
                <button
                  type="button"
                  className="luxury-maybe-later"
                  onClick={() => setUpgradeModalVisible(false)}
                >
                  Maybe Later
                </button>
                <span className="luxury-trust-note">
                  Instant access • Choose the plan right for you
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default InspectorProfile;